module.exports = __webpack_public_path__ + "static/media/liftoff-hor-en.36027887.png";